import RECOMMENDATIONS from "@/data/recommendations.yml";
import ContentBlock from "@/components/content-block";
import dynamicLocalization from "@/mixins/dynamic-localization";

export default {
  components: { ContentBlock },
  mixins: [dynamicLocalization],
  data() {
    return {
      RECOMMENDATIONS,
    };
  },
};
